import { useEffect } from 'react';
import Wrapper from '@/components/wrapper';
import { getServerSideProps as _getServerSideProps, getHead } from '@/utils/useHead';

export async function getServerSideProps(context: any) {
  const res: any = await _getServerSideProps(context, 42);
  return {
    props: {
      ...res.props,
    }
  }
}

export default ({ menuDetail }: any) => {
  useEffect(() => {
    setTimeout(() => {
      const str = document.getElementById("reactCode")?.innerText || 'console.log()';
      eval(str)
    }, 0);
  }, [menuDetail]);
  return (
    <div>
      <Wrapper>
        <>
          {getHead(menuDetail)}
          <div className="m-1600" dangerouslySetInnerHTML={{ __html: menuDetail?.info?.content }} />
        </>
      </Wrapper>
    </div>
  );
};
